import { sync } from 'vuex-router-sync'
import createStore from './store'
import createRouter from './router'

export default () => {
  const store = createStore()
  const router = createRouter({ store })
  sync(store, router, { moduleName: 'route' })
  return { store, router }
}
